module.exports = __webpack_public_path__ + "img/arrow-down-a-z.9034ebe0.svg";